import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {ChatState} from '../types/chat.types';

const INITIAL_STATE = {
  messages: [],
  responseType: 'text',
  responseFlow: '',
  messageEdit: {},
  responseMode: '',
  messageTextEdit: '',
  responseTypeBack: '',
  responseFlowBack: '',
  chatStageFlow: 10,
  listProductsSelected: [],
  listInputCode: [],
  psrInputOwnerId: null,
  banksList: [],
  listCodePsr: [],
  bankObject: {
    name: '',
    code: '',
    branch: '',
    account: '',
    accountType: {
      bankAccountType: '',
      description: ''
    }
  },
  quizPartners: []
};

export const useChatStore = create<ChatState>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      loadMessages: (messages) =>
        set({messages: [...messages]}, false, 'chat/loadMessages'),

      sendMessage: (message) =>
        set(
          (state) => {
            const newMessage = {
              buttonEditable: false,
              ...message,
              id: state.messages.length + 1
            };
            return {messages: [...state.messages, newMessage]};
          },
          false,
          'chat/sendMessage'
        ),

      setMessages: (messages) =>
        set(
          (state) => {
            let count = state.messages.length;
            const newMessages = messages.map((msg) => {
              count++;
              return {
                text: '',
                type: 'message-receive',
                buttonEditable: false,
                ...msg,
                id: count
              };
            });
            return {messages: [...state.messages, ...newMessages]};
          },
          false,
          'chat/setMessages'
        ),

      responseTypeChange: (type) =>
        set({responseType: type}, false, 'chat/responseTypeChange'),

      responseFlowChange: (flow) =>
        set({responseFlow: flow}, false, 'chat/responseFlowChange'),

      responseModeChange: (updateMessage) =>
        set(
          {
            messageEdit: updateMessage.messageEdit,
            responseMode: updateMessage.responseMode,
            messageTextEdit: updateMessage.messageTextEdit,
            responseTypeBack: updateMessage.responseTypeBack,
            responseFlowBack: updateMessage.responseFlowBack
          },
          false,
          'chat/responseModeChange'
        ),

      setChatStageFlow: (stage) =>
        set({chatStageFlow: stage}, false, 'chat/setChatStageFlow'),

      setChatInputCode: (codes) =>
        set({listInputCode: codes}, false, 'chat/setChatInputCode'),

      setPsrInputOwnerId: (id) =>
        set({psrInputOwnerId: id}, false, 'chat/setPsrInputOwnerId'),

      setChaProductSelect: (products) =>
        set(
          {listProductsSelected: products},
          false,
          'chat/setChaProductSelect'
        ),

      setChaListCode: (codes) =>
        set({listCodePsr: codes}, false, 'chat/setChaListCode'),

      setBanksListGlobal: (banks) =>
        set({banksList: banks}, false, 'chat/setBanksListGlobal'),

      setBankObject: (bank) =>
        set({bankObject: bank}, false, 'chat/setBankObject'),

      setQuizPartners: (partners) =>
        set({quizPartners: partners}, false, 'chat/setQuizPartners')
    }),
    {name: 'ChatStore'}
  )
);

export const selectMessages = (state: ChatState) => state.messages;
export const selectResponseType = (state: ChatState) => state.responseType;
export const selectResponseFlow = (state: ChatState) => state.responseFlow;
export const selectMessageEdit = (state: ChatState) => state.messageEdit;
export const selectResponseMode = (state: ChatState) => state.responseMode;
export const selectChatStageFlow = (state: ChatState) => state.chatStageFlow;
export const selectListProductsSelected = (state: ChatState) =>
  state.listProductsSelected;
export const selectListInputCode = (state: ChatState) => state.listInputCode;
export const selectPsrInputOwnerId = (state: ChatState) =>
  state.psrInputOwnerId;
export const selectBanksList = (state: ChatState) => state.banksList;
export const selectListCodePsr = (state: ChatState) => state.listCodePsr;
export const selectBankObject = (state: ChatState) => state.bankObject;
export const selectQuizPartners = (state: ChatState) => state.quizPartners;
